import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsSection, SettingsSectionTitleDict} from "../../../app/settings/@const";

// const debug = "StoryPointsModule"
const debug = false

export class StoryPointsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.STORY_POINTS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Story points"
        this.description             = "The Story Points module simplifies task estimation by allowing users to assign story points to tasks based on their complexity within projects."
        this.svgIcon                 = "isvg-story-points"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS]
        this.settingsUrl             = "settings/story-points"


        this.feature                 = Feature.CUSTOM_STORY_POINTS
        this.validateFeature()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}